module.exports = __webpack_public_path__ + "static/media/Supported-Living-img.368cfe1f.jpg";